import { render, staticRenderFns } from "./AssessmentReportRoute.vue?vue&type=template&id=1d00daae"
import script from "./AssessmentReportRoute.vue?vue&type=script&lang=js"
export * from "./AssessmentReportRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports